import PhoneNumberCaption from './PhoneNumberCaption';

export default PhoneNumberCaption;
